<script setup>
import { ref, onMounted } from "vue"
import bus from "../utils/eventBus.js"
import FieldDate from "./FieldDate.vue"
import FieldAge from "./FieldAge.vue"
import FieldCategory from "./FieldCategory.vue"
import FieldOther from "./FieldOther.vue"
import FeedService from "../services/FeedService.js"
import { useFilteredFeedStore } from "../utils/store.js"

const store = useFilteredFeedStore()

const keyword = ref(null)
const categories = ref([])
const ages = ref([])
const date = ref(null)

const toggled = ref(false)

onMounted(() => {
	FeedService.getTaxonomies()
		.then((response) => {
			categories.value = response.data['event-categories']
			ages.value = response.data['age-range']
			if( response.data['cta'] ){
				store.featureButton = response.data['cta']
			}
			if( response.data['whatson_page_url'] ){
				store.whatsOnBaseURL = response.data['whatson_page_url']
			}
		})
		.catch((error) => {
			console.log(error)
		})
	
	// bus.on((e) => {
	// 	doFilter()
	// })
})

function doFilter() {
	bus.emit('go');
	// if (store.filters) {
	// 	store.fetchItems()
	// }
}

</script>

<template>
	<section class="relative z-30">
		<div data-filter-header>
			<!-- <div class="bg-purple text-white py-12">
				<div class="container">
					<span class="text-lg font-bold font-serif">What do you want to do?</span>
				</div>
			</div> -->
			<div class="bg-lilac text-white">
				<div class="container relative py-6">

					<Transition>
						<a :href="store.featureButton.url" v-if="store.featureButton" class="group circle-btn hidden md:flex absolute right-16 top-0 -translate-y-1/3 bg-teal text-black">
							<span>{{ store.featureButton.title }}</span>
							<em class="gfx gfx-rocket w-14 xl:w-20 absolute left-full -ml-10 top-0 group-hover:shake" aria-hidden="true"></em>
						</a>
					</Transition>
					
					<div class="flex flex-col divide-y-2 divide-purple text-nav">

						<button v-if="Object.keys(store.filters).length !== 0" @click.prevent="doFilter()" class="btn bg-orange hover:bg-orange-tint text-black px-12 md:hidden justify-center">See results</button>

						<FieldDate />
						<FieldCategory :categories="categories" />
						<FieldAge :ages="ages" />
						<FieldOther />

						<footer class="py-6 flex items-center gap-8 justify-between">
							<div>
								<a v-if="Object.keys(store.filters).length !== 0" @click.prevent="store.resetApp()" href="#" class="link text-sm">Reset all filters</a>
							</div>
							<button @click.prevent="doFilter()" class="btn bg-orange hover:bg-orange-tint text-black px-12">See results</button>
						</footer>

					</div>
				</div>
			</div>
		</div>
	</section>
</template>
